<template>
    <div class="row">
        <div id="handoverMap" class="col-lg-12 col-7"></div>

        <div class="d-none d-lg-block alert alert-info mt-3 col-lg-12">
            <div class="row">
                <div class="col-1 d-flex justify-content-center align-items-center">
                    <i class="fal fa-exclamation-circle fa-2x"></i>
                </div>
                <div class="col-11">
                <span v-html="navigation.message">
                </span>
                </div>
            </div>
        </div>

        <div class="col-5 d-block d-lg-none d-flex align-items-stretch">
            <div class="alert alert-info mb-0">
                <div class="row">
                    <div class="col-12 d-flex justify-content-center text-center py-1">
                        <i class="fal fa-exclamation-circle fa-2x"></i>
                    </div>
                    <div class="col-12 text-center py-3 d-flex align-items-center">
                        <span v-html="navigation.message"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PNotify from 'pnotify/dist/es/PNotify';
    import PNotifyStyleMaterial from 'pnotify/dist/es/PNotifyStyleMaterial.js';

    PNotify.defaults.styling = 'bootstrap4';
    PNotify.defaults.icons = 'fontawesome5';

    export default {
        name: "MapRoute",
        props: {
            origin: {
                type: Object,
                required: true
            },
            destination: {
                type: Object,
                required: true
            },
            costs: {
                type: String,
                required: false
            },
            stepRegisterUrl: {
                type: String,
                required: false
            }
        },
        watch: {
            origin: {
                handler(newValue, oldValue) {
                    if (this.isDifferentAddress(newValue, oldValue)) {
                        axios.get("https://maps.googleapis.com/maps/api/geocode/json", {
                            params: {
                                address: this.origin,
                                key: this.$googleMapsApi
                            }
                        }).then(result => {
                            this.setStart(result.data.results[0]);
                            this.initMap();
                            this.calcRoute();
                            PNotify.success("Route neu berechnet!");
                        }).catch(error => {
                            PNotify.error("Es kam zu einem Fehler bei der Neuberechnung der Route...");
                        });
                    } else {
                    }
                },
                deep: false
            }
        },
        data() {
            return {
                api: {
                    directionsUrl: 'https://maps.googleapis.com/maps/api/directions/json?origin=%origin%&destination=%destination%&key=%key%'
                },
                map: {
                    map: {},
                    options: {},
                    directionsService: {},
                    directionsDisplay: {}
                },
                start: {
                    loaded: false,
                    location: {}
                },
                navigation: {
                    show: false,
                    distance: 0,
                    duration: 0,
                    message: ""
                },
                googleFailed: false
            }
        },
        computed: {
            getDirectionsApiUrl() {
                let url = this.api.directionsUrl;
                url = url.replace("%key%", this.$googleMapsApi);

                let origin = this.origin.street + " " + this.origin.house_number + " " + this.origin.postal_code + " " + this.origin.city;
                url = url.replace("%origin%", origin);

                let destination = this.destination.street + " " + this.destination.house_number + " " + this.destination.postal_code + " " + this.destination.city;
                url = url.replace("%destination%", destination);
            }
        },
        methods: {
            isDifferentAddress(address1, address2) {
                return address1.street !== address2.street ||
                    address1.postal_code !== address2.postal_code ||
                    address1.city !== address2.city ||
                    address1.country !== address2.country;
            },
            slugify(string) {
                return string.replace(/\s/g, "+");
            },
            setStart(data) {
                this.start.location = {
                    address: data.formatted_address,
                    coordinates: data.geometry.location
                };
                this.start.loaded = true;
            },
            initMap() {
                this.map.directionsService = new google.maps.DirectionsService();
                this.map.directionsDisplay = new google.maps.DirectionsRenderer();
                let home = new google.maps.LatLng(this.start.location.coordinates.lat, this.start.location.coordinates.lng);
                this.map.options = {
                    center: home,
                    zoom: 7,
                    disableDefaultUI: true
                };
                this.map.map = new google.maps.Map(document.getElementById('handoverMap'), this.map.options);
                this.map.directionsDisplay.setMap(this.map.map);
            },
            calcRoute() {
                let destination = this.destination.street
                    + " " + this.destination.house_number
                    + ", " + this.destination.postal_code
                    + " " + this.destination.city
                    + ", " + this.destination.country;
                let self = this;
                let request = {
                    origin: this.start.location.address,
                    destination: destination,
                    travelMode: 'DRIVING'
                };

                this.map.directionsService.route(request, function (result, status) {
                    if (status == 'OK') {
                        self.navigation.distance = result.routes[0].legs[0].distance;
                        self.navigation.duration = result.routes[0].legs[0].duration;
                        self.map.directionsDisplay.setDirections(result);
                        self.navigation.message = "Du wärst ca. <strong>" + self.navigation.duration.text + " für die " + self.navigation.distance.text + "</strong> lange Strecke unterwegs.";
                        self.navigation.show = true;
                    } else {
                        console.warn('Fehler in der Routenberechnung');
                    }
                })
            }
        },
        async mounted() {
            axios.defaults.headers.common = {};
            const startData = await axios.get("https://maps.googleapis.com/maps/api/geocode/json", {
                params: {
                    address: this.origin,
                    key: this.$googleMapsApi
                }
            });
            if (startData.data.status === 'ZERO_RESULTS') {
                this.googleFailed = true;
            } else {
                this.setStart(startData.data.results[0]);
                this.initMap();

                await this.calcRoute();
            }

        }
    }
</script>

<style scoped lang="scss">
    #handoverMap {
        width: 100%;

        @media (min-width: 992px) {
            height: 300px;
        }

        @media (max-width: 991px) {
            height: 200px;
        }
    }

    i.fal {
        color: #0b97c4;
    }
</style>